import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';
import { Icon } from 'front-onceforall-core';
import { Translate } from 'react-redux-i18n';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProjectEditionButton = props => {
  return /*#__PURE__*/_jsx("div", {
    className: "flex-container justify-content-end",
    children: /*#__PURE__*/_jsx(Tooltip, {
      "data-id": "edit-enabledTooltip-tooltip",
      title: /*#__PURE__*/_jsx(Translate, {
        value: "project.edit.enabledTooltip"
      }),
      children: /*#__PURE__*/_jsx("button", {
        "data-id": "edit",
        className: "large secondary inline-container",
        onClick: props.onEditButtonClick,
        children: /*#__PURE__*/_jsx(Icon, {
          icon: "edit"
        })
      })
    })
  });
};
ProjectEditionButton.propTypes = {
  onEditButtonClick: PropTypes.func.isRequired
};
export default ProjectEditionButton;